import { render, staticRenderFns } from "./comparTable.vue?vue&type=template&id=aad91414&scoped=true&"
import script from "./comparTable.vue?vue&type=script&lang=js&"
export * from "./comparTable.vue?vue&type=script&lang=js&"
import style0 from "./comparTable.vue?vue&type=style&index=0&id=aad91414&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad91414",
  null
  
)

export default component.exports